import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { createUserWithEmailAndPassword, getAuth } from 'firebase/auth';
import {
  getFirestore,
  doc,
  setDoc,
  getDoc,
  query,
  collection,
  where,
  getDocs
} from 'firebase/firestore';
import appFirebase from '../Firebase/Firebase';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const auth = getAuth(appFirebase);
const db = getFirestore(appFirebase);
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const AutoRegisterFromExcel = () => {
  const [progress, setProgress] = useState(0);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const checkIfUserExists = async (email) => {
    const usuariosRef = collection(db, 'usuarios');
    const q = query(usuariosRef, where('email', '==', email));
    const snapshot = await getDocs(q);
    return !snapshot.empty;
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    setProgress(0);
    setIsLoading(true);

    reader.onload = async (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: 'binary' });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws, { defval: '' });

      setTotal(data.length);

      let count = 0;
      for (const row of data) {
        const name = row['N']?.toString().trim();
        const nombreURL = row['URL SMART-CONNECT']?.toString().trim().replace(/\s+/g, '');
        const email = row['Correo']?.toString().trim();
        const telefono = row['tel']?.toString().trim();

        if (!email || !name) {
          console.warn(`⚠️ Fila inválida:`, row);
          continue;
        }

        try {
          const existsInUsuarios = await checkIfUserExists(email);

          if (existsInUsuarios) {
            console.log(`⚠️ Usuario ya registrado en la colección: ${email}`);
            toast.info(`⚠️ Usuario ya existe: ${email}`);
          } else {
            const password = 'LaOfi123';
            const credentials = await createUserWithEmailAndPassword(auth, email, password);

            const userData = {
              userId: credentials.user.uid,
              name,
              email,
              nombreURL,
              role: 'user',
              coins: 200,
              coinsComprados: 200,
              coinRenovation: new Date(),
              coinExpiration: new Date(new Date().setDate(new Date().getDate() + 30)),
              perfilNegocio: {
                nombre: name,
                telefono: telefono || ''
              }
            };

            const userDocRef = doc(db, 'usuarios', credentials.user.uid);
            const userDocSnap = await getDoc(userDocRef);

            if (userDocSnap.exists()) {
              console.log(`📦 Documento ya existe, no se sobrescribe: ${email}`);
              toast.info(`📦 Ya existe doc Firestore: ${email}`);
            } else {
              await setDoc(userDocRef, userData);
              console.log(`✅ Usuario creado y guardado: ${email}`);
              toast.success(`✅ Usuario creado: ${email}`);
            }
          }
        } catch (err) {
          console.error(`❌ Error con ${email}:`, err.message);
          toast.error(`❌ Error con ${email}: ${err.message}`);
        } finally {
          count++;
          setProgress(count);
          await sleep(1000);
        }
      }

      setIsLoading(false);
      toast.info('🎉 Registro masivo finalizado');
    };

    reader.readAsBinaryString(file);
  };

  return (
    <div style={{ padding: '20px', maxWidth: '500px', margin: 'auto' }}>
      <h3>📥 Registro automático desde Excel</h3>
      <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} disabled={isLoading} />

      {isLoading && (
        <div style={{ marginTop: '20px' }}>
          <p>Procesando usuarios: {progress} / {total}</p>
          <div style={{ backgroundColor: '#ddd', borderRadius: '10px', overflow: 'hidden' }}>
            <div
              style={{
                width: `${(progress / total) * 100}%`,
                backgroundColor: '#4caf50',
                height: '20px',
                transition: 'width 0.3s'
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AutoRegisterFromExcel;
